export const UserListColumnsModel = [
  {
    label: 'Email',
    property: 'email',
    type: 'string'
  },
  {
    label: 'Name',
    property: 'name',
    type: 'string'
  },
  {
    label: 'Groups',
    template: {
      type: 'content',
      property: 'groupsAsHtml'
    },
    width: 50,
    type: 'html'
  },
  {
    label: 'Customer',
    template: {
      type: 'content',
      property: 'customerNumbersAsHtml'
    },
    width: 50,
    type: 'html'
  }
];
